export default "__VITE_ASSET__C8d7whPL__"